import { createContext, useReducer } from "react";
import userReducer from "./userReducer";
import {jwtDecode} from 'jwt-decode';

const INITIAL_STATE = {
    role: sessionStorage.getItem('accessToken') ?
           jwtDecode(sessionStorage.getItem('accessToken')).role : 'guest'
}

export const userContext = createContext(INITIAL_STATE);

export const UserContextProvider = ({children}) => {

    const [state,dispatchUser] = useReducer(userReducer,INITIAL_STATE);

    return (
        <userContext.Provider value={{role:state.role,dispatchUser}}>
            {children}
        </userContext.Provider>
    )
    
}